<template>
  <Dialog :open="value" @close="$emit('input', false)">
    <template v-slot:title>
      <Label text="スカウト送付者の編集" size="h5" bold />
    </template>
    <FlexColumn>
      <FlexRow justify="end">
        <RequiredItemText/>
      </FlexRow>
      <RequestorForm v-model="requestor" ref="requestorForm" />
    </FlexColumn>
    <template v-slot:actions>
      <FlexRow align="center" justify="center" full-width>
        <TextButton @click="$emit('input', false)">キャンセル</TextButton>
        <Button outlined @click="handleSubmit">保存</Button>
      </FlexRow>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "../atoms/Dialog";
import Label from "../atoms/Label";
import FlexColumn from "../atoms/FlexColumn";
import FlexRow from "../atoms/FlexRow";
import RequiredItemText from "../atoms/RequiredItemText";
import RequestorForm from "./RequestorForm";
import TextButton from "../atoms/TextButton";
import Button from "../atoms/Button";
import ApiMixin from "../../ApiMixin";
export default {
  name: "RequestorEditDialog",
  mixins: [ApiMixin],
  components: {Button, TextButton, RequestorForm, RequiredItemText, FlexRow, FlexColumn, Label, Dialog},
  props: {
    value: {
      type: Boolean
    },
    companyId: {
      type: String
    },
    requestor: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async handleSubmit() {
      await this.saveRequestor(
          this.companyId, this.requestor.id,
          this.requestor.firstName, this.requestor.lastName, this.requestor.post)
      if (this.requestor.icon instanceof File) {
        await this.uploadRequestorImage(this.companyId, this.requestor.id, this.requestor.icon)
      }
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>

</style>